'use client';

import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

let globalLenis: Lenis | null = null; // глобальный экземпляр

export default function SmoothScroll() {
  const lenisRef = useRef<Lenis | null>(null);

  const initLenis = () => {
    if (globalLenis) return globalLenis;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      touchMultiplier: 2,
    });
    globalLenis = lenis;
    lenisRef.current = lenis;

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return lenis;
  };

  const destroyLenis = () => {
    if (globalLenis) {
      globalLenis.destroy();
      globalLenis = null;
      lenisRef.current = null;
    }
  };

  useEffect(() => {
    initLenis();

    const handleLock = (e: Event) => {
      const { isLocked } = (e as CustomEvent).detail;
      if (isLocked) {
        destroyLenis(); // полностью удаляем Lenis
      } else {
        initLenis(); // воссоздаём заново
      }
    };

    window.addEventListener('lenis-lock', handleLock as EventListener);
    return () => {
      window.removeEventListener('lenis-lock', handleLock as EventListener);
      destroyLenis();
    };
  }, []);

  return null;
}